import { DcTenantCode } from './tenant';

export type CountryCode = 'AU' | 'NZ' | 'US';
export type SupportedLanguageCode = 'en_AU' | 'en_NZ' | 'en_US';

export interface DcLocaleConfig {
  readonly countryCode: CountryCode;
  readonly langauge: {
    default: SupportedLanguageCode;
    supported: SupportedLanguageCode[];
  };
}

const DC_LOCALE_CONFIG: Record<DcTenantCode, DcLocaleConfig> = {
  au: {
    countryCode: 'AU',
    langauge: {
      default: 'en_AU',
      supported: ['en_AU'],
    },
  },
  nz: {
    countryCode: 'NZ',
    langauge: {
      default: 'en_NZ',
      supported: ['en_NZ'],
    },
  },
  us: {
    countryCode: 'US',
    langauge: {
      default: 'en_US',
      supported: ['en_US'],
    },
  },
  global: {
    countryCode: 'US',
    langauge: {
      default: 'en_US',
      supported: ['en_US'],
    },
  },
};

export function getDcLocaleConfigFromTenantCode(code: DcTenantCode): DcLocaleConfig {
  const locale = DC_LOCALE_CONFIG[code];
  if (!locale) {
    throw new Error(`Unsupported tenant code: ${code}`);
  }
  return locale;
}
